module.exports = __webpack_public_path__ + "img/city_04.7647cd42.png";